import useStore from '@/hooks/useStore.js'
import Icon from '@mdi/react'
import { mdiMagnifyRemoveOutline } from '@mdi/js'
import { Button } from '@/components/ui/button.jsx'
import { Link } from '@tanstack/react-router'
import { observer } from 'mobx-react-lite'

const PageNotFoundError = ({ ...props }) => {
  const { routerStore } = useStore()

  return (
    <div {...props} className="flex grow flex-col items-center justify-center gap-6 p-3">
      <Icon className="max-h-fit w-full max-w-32" path={mdiMagnifyRemoveOutline} size="100%" />

      <h1 className="text-center text-2xl">The page you are looking for does not exist</h1>

      <Button asChild>
        <Link to={routerStore.routes.index}>Go Home</Link>
      </Button>
    </div>
  )
}

export default observer(PageNotFoundError)
